import {
  DeconstructedDate,
  DeconstructedDateTime,
  DeconstructedDateTimeTz, DeconstructedDuration,
  DeconstructedTime, DeconstructedTimeOffset, DeconstructedTimeTz, DeconstructedWeekDuration
} from './deconstruct-date.function';
import {
  IsoDate,
  IsoDuration,
  IsoDateTime,
  IsoDateTimeTz,
  IsoTime, IsoTimeOffset,
  IsoTimeTz,
  IsoWeekDuration
} from '../../types/iso-date';
export function constructDate<T extends DeconstructedDate | DeconstructedDateTime | DeconstructedDateTimeTz | DeconstructedTime | DeconstructedTimeTz | DeconstructedDuration | DeconstructedWeekDuration>(date: T):
  T extends DeconstructedDate ? IsoDate :
  T extends DeconstructedDateTime ? IsoDateTime :
  T extends DeconstructedDateTimeTz ? IsoDateTimeTz :
  T extends DeconstructedTime ? IsoTime :
  T extends DeconstructedTimeTz ? IsoTimeTz :
  T extends DeconstructedDuration ? IsoDuration :
  T extends DeconstructedWeekDuration ? IsoWeekDuration :
  never {
  let returnValue = '';
  if (date._type === 'date' || date._type === 'dateTime' || date._type === 'dateTimeTz') {
    const year = date.year.toString().padStart(4, '0');
    const month = date.month.toString().padStart(2, '0');
    const day = date.day.toString().padStart(2, '0');
    returnValue += `${year}-${month}-${day}`;
  }
  if( date._type === 'dateTime' || date._type === 'dateTimeTz') {
    returnValue += 'T';
  }
  if( date._type === 'dateTime' || date._type === 'dateTimeTz' || date._type === 'time' || date._type === 'timeTz') {
    const hours = date.hours.toString().padStart(2, '0');
    const minutes = date.minutes.toString().padStart(2, '0');
    const seconds = date.seconds.toString().padStart(2, '0');
    const fraction = date.milliseconds.toString().padStart(3, '0').replace(/0+$/, '');
    returnValue += `${hours}:${minutes}:${seconds}`;
    if (fraction) {
      returnValue += `.${fraction}`;
    }
  }
  if(date._type === 'dateTimeTz' || date._type === 'timeTz')
    returnValue += constructOffset(date.offset);

  if(date._type === 'duration' || date._type === 'weekDuration') {
    returnValue += 'P';
  }
  if(date._type === 'weekDuration') {
    if(date.years)
      returnValue += `${date.years}Y`;
    if(date.weeks)
      returnValue += `${date.weeks}W`;
  }
  if(date._type === 'duration') {
    if (date.years)
      returnValue += `${date.years}Y`;
    if (date.months)
      returnValue += `${date.months}M`;
    if (date.days)
      returnValue += `${date.days}D`;
    if( date.hours || date.minutes || date.seconds || date.milliseconds)
      returnValue += 'T';
    if(date.hours)
      returnValue += `${date.hours}H`;
    if(date.minutes)
      returnValue += `${date.minutes}M`;
    if(date.seconds || date.milliseconds) {
      let seconds = date.seconds ? date.seconds.toString() : '0';
      if(date.milliseconds) {
        const ms = date.milliseconds.toString().padStart(3, '0').replace(/0+$/, '');
        seconds += `.${ms}`;
      }
      returnValue += `${seconds}S`;
    }
    if(returnValue === 'P')
      returnValue += '0D';
  }
  return returnValue as any;
}

export function constructOffset(offset: 'Z' | DeconstructedTimeOffset): IsoTimeOffset {
  if( offset === 'Z')
    return 'Z' as IsoTimeOffset;
  const sign = offset.offsetSign.startsWith('+') ? '+' : '-';
  const tzHours = offset.offsetHours.toString().padStart(2, '0');
  const tzMinutes = offset.offsetMinutes.toString().padStart(2, '0');
  return `${sign}${tzHours}:${tzMinutes}` as IsoTimeOffset;
}
